export default "__VITE_ASSET__DktKEWn3__"